import React, { useState } from "react";
import { Switch } from "antd";
import { Link } from "react-router-dom";
import { apiRequest } from "../../../api";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import * as PageReducer from "./PageReducer";

export const TableRow = ({ item, index, refresh, setRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const dispatch = useDispatch();

  const getPages = () => {
    apiRequest({
      method: "GET",
      url: "page",
    })
      .then((resp) => {
        dispatch(PageReducer.actions.pageList(resp.data));
      })
      .catch((error) => {
        console.log("get all news list error", error);
      });
  };

  const handleCheckedClick = (checked) => {
    setLoading(true);
    apiRequest({
      method: "PUT",
      url: `/page/${item.id}/status`,
      data: {
        status: checked ? "ACTIVE" : "INACTIVE",
      },
    })
      .then(() => {
        setLoading(false);
        refresh ? setRefresh(false) : setRefresh(true);
        getPages();
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
          width: 400,
        });
      });
  };

  const handleDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete this item.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setDelLoading(true);
        apiRequest({
          method: "DELETE",
          url: `/page/${item.id}`,
        })
          .then(() => {
            setDelLoading(false);
            getPages();
            window.location.reload();
          })
          .catch((error) => {
            setDelLoading(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message,
              width: 400,
            });
          });
      }
    });
  };

  return (
    <tr>
      <th scope="row">{index + 1}</th>
      <td>{item.title}</td>
      <td>{item.sku}</td>
      <td>{item.status}</td>
      <td>{item.updated_by}</td>

      <td>
        <Link to={`/pages/edit/${item.sku}`}>
          <i className="icon-pencil"></i>
        </Link>
        {delLoading ? (
          <span className="indicator-progress">
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        ) : (
          <button type="button" onClick={handleDelete}>
            <i className="icon-trash"></i>
          </button>
        )}
      </td>

      <td>
        <Switch
          key={item.status}
          checked={item.status === "ACTIVE"}
          onChange={handleCheckedClick}
          loading={loading}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      </td>
    </tr>
  );
};
